import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
  domainSquating,
  takeDown,
  bulkTakeDown,
  domainSquatingTotal,
  domainSquatingExcel,
  domainSquatingAction,
  domainSquatingDomain,
  addLookalikeDomain
} from "../../actions/look-alike";
import "../../assets/css/details-slider.css";
import "../../assets/css/recommendation-modal.css";
import BasicLineColumn from "../common/apexChart/lineChart";
import Pagination from "../Pagination/Pagination";
import TrialComponent from "../common/trialComponent";
import ScanMessage from "../common/scanningMessage";
// import TinyMCE from "react-tinymce";
import { toastr } from "react-redux-toastr";
import AccessPage from "../Shared/accessPage";
import axios from "axios";
import { API_URL } from "../../utils/constant";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import $, { data } from "jquery";
import { rescanSingle } from "../../actions/users";
import PieChart from "../../components/common/dashboard12/piechart.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isValid } from "date-fns";
import moment from "moment";
import TicketDetailsModal from "../common/TicketDetailsModal";
import ImageModal from "../common/ImageModal";

var Model = require("../Shared/model");

const Domains = () => {
  // const id = JSON.parse(localStorage.getItem("user")).organisationId;
  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });
  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );

  const auth = useSelector((state) => state?.auth?.user);

  let domain = client?.website?.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "");
  if (domain?.charAt(domain.length - 1) == "/") {
    domain = [domain.substr(0, domain.length - 1)];
    // domain.unshift("all");
  } else {
    domain = [domain];
    // domain.unshift("all");
  }
  if (client?.domains && client.domains.length > 0) {
    domain = client.domains;
    // domain.unshift("all");
  }

  const dispatch = useDispatch();

  const [subject, setSubject] = useState("");
  const [stolenLocation, setStolenLocation] = useState("");
  const [contenSource, setContenSource] = useState("");
  const [infringingIp, setInfringingIp] = useState("");
  const [editorContent, setEditorContent] = useState("");
  const [rowId, setRowId] = useState("");
  const [domainFilter, setDomainFilter] = useState("all");
  const [isModalIp, setIsModalIp] = useState("all");
  const [ownerDetail, setOwnerDetails] = useState("");
  const [ownerDetailsData, setOwnerDetailsData] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [ipData, setIpData] = useState([]);

  const dnsTableRef = useRef(null);
  const ownerTableRef = useRef(null);

  const [filterData, setfilterData] = useState("all");
  const [isModal, setModal] = useState("");
  const [isModalDns, setModalDns] = useState("");
  const [isTakeDownModal, setTakeDownModal] = useState("");
  const [isBulkTakeDownModal, setBulkTakeDownModal] = useState(false);
  const [bulkTakeDownComment, setBulkTakeDownComment] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedRow, setSelectedId] = useState([]);

  // const [domains, setDomains] = useState([]);
  const [FirstLoad, setFirstLoad] = useState(true);
  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(10);
  const [category, setCategory] = useState("all");
  const [isModalTable, setModalTable] = useState("");
  const [forValue, setForValue] = useState("forever");
  const [lookalikeAppId, setLookalikeAppId] = useState("");
  const [actionNote, setActionNote] = useState("");
  const [action, setAction] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const vendorName = sessionStorage.getItem('vendorName');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const vendorId = sessionStorage.getItem('vendorId');
  const [subdomain, setSubdomain] = useState("all");
  const [limit, setLimit] = useState(10);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedDomain, setSelectedDomain] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);
  const [loadingScreenshots, setLoadingScreenshots] = useState({});
  const [tableLoading, setTableLoading] = useState(false);
  const [userComment, setUserComment] = useState("");
  const [showWhois, setShowWhois] = useState(false);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [imageModalSrc, setImageModalSrc] = useState("");
  const [isAddLookalikeModal, setIsAddLookalikeModal] = useState(false);
  const [isTicketDetailsModal, setIsTicketDetailsModal] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [isRecommendationModal, setIsRecommendationModal] = useState(false);
  const [activeRecommendationTab, setActiveRecommendationTab] = useState('guide');
  const [newLookalikeDomain, setNewLookalikeDomain] = useState({
    organisationId: "",
    lookalike: "",
    original: "",
    fuzzer: "typo"
  });
  const [fuzzerOptions] = useState(["typo", "homograph", "bitsquatting", "hyphenation", "addition", "omission"]);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const fileInputRef = useRef(null);


  const domains = useSelector(
    (state) => state?.lookAlike?.domainSquating?.data?.data
  );
  const userPermission = useSelector(state => {
    return state?.auth?.user?.modulePermissionsConfig?.bs?.e;
  });
  const totalCount = useSelector(
    (state) => state?.lookAlike?.domainSquating?.data?.totalRecords
  );
  const scanCompleted = useSelector((state) => state?.lookAlike?.scanCompleted);
  const subDomainList = useSelector(
    (state) => state?.lookAlike?.subDomainList?.data?.domains
  );

  const totalLookLikeCount = useSelector(
    (state) => state?.lookAlike?.lookaliketotal?.data
  );

  const [totalItems, setTotalItems] = useState(0);

  const scanDetails = useSelector(
    (state) => state?.lookAlike?.lookalikeGraph?.data
  );


  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };

  const singleClick = (id, data) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };

  // Submit bulk takedown request
  const submitBulkTakeDown = async () => {
    if (bulkTakeDownComment.trim() === "") {
      toastr.error("Error", "Comment cannot be empty.");
      return false;
    }

    if (selectedIds.length === 0) {
      toastr.error("Error", "Please select at least one record.");
      return false;
    }

    try {
      // Build entries array from selected IDs
      const entries = selectedIds.map((recordId) => ({
        recordId: recordId,
        moduleName: "lookalike",
        userComment: bulkTakeDownComment,
      }));

      setBulkTakeDownModal(false);
      
      // Call bulk takedown API
      const response = await bulkTakeDown(id, entries, dispatch);
      
      // Refresh the listing after successful bulk takedown request
      if (response && !response.error) {
        domainSquating(id, dispatch, page, filterData, category, startDate, endDate, PageSize, subdomain);
        setSelectedIds([]);
        setMultiCheckTrue(false);
      }
      
      // Reset form
      setBulkTakeDownComment("");
    } catch (error) {
      console.error("Error submitting bulk takedown request:", error);
    }
  };

  const snooze = (_id, event) => {
    if (event === "markAsRemidiated") {
      $.confirm({
        title: "Are you sure?",
        content: "Do you really want to mark this as remediated for the selected lookalike domains?",
        type: "green", // Customize as needed
        buttons: {
          ok: {
            text: "Yes, Mark as Remediated",
            btnClass: "btn-success",
            keys: ["enter"],
            action: function () {
              let ids = [];
              ids.push(_id);
              const data = {
                action: "markAsRemediated",
                lookalikeDomainIds: selectedIds.length === 0 ? ids : selectedIds,
                actionNote: "",
                for: "forever",
              };
              domainSquatingAction(
                id,
                dispatch,
                data,
                page,
                category,
                subdomain,
                filterData
              );
              setSelectedValue("pleaseSelect");
              setActionNote("");
              setSelectedIds([]);
            },
          },
          cancel: function () {
            // User canceled, do nothing
          },
        },
      });
    }

  };

  const Unsnoozed = (_id) => {
    let ids = [];
    ids.push(_id);
    const data = {
      action: "resetAction",
      lookalikeDomainIds: selectedIds == 0 ? ids : selectedIds,
    };
    domainSquatingAction(
      id,
      dispatch,
      data,
      page,
      category,
      subdomain,
      filterData
    );
    setSelectedIds([]);
  };

  const submit = () => {
    const data = {
      action: action,
      lookalikeDomainIds: selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
    };
    domainSquatingAction(
      id,
      dispatch,
      data,
      page,
      category,
      subdomain,
      filterData
    );
    setActionNote("");
    setModalTable("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
  };

  const openOwnerDetails = (res) => {
    setOwnerDetails("Form Wizard owner details");
    setOwnerDetailsData(res?.ownerDetails);
  }

  const addModal = () => {
    setModalTable("Form Wizard modal");
  };

  const addModalIp = () => {
    setIsModalIp("Form Wizard modal Ip");
  };

  let ipArray = [];
  for (let details = 0; details < scanDetails?.scanDetails?.length; details++) {
    ipArray.push(scanDetails?.scanDetails[details]);
  }

  useEffect(() => {
    return () => {
      document.body.classList.remove("details-slider-open");
    };
  }, []);

  useEffect(() => {
    if (showDetailModal) {
      document.body.classList.add("details-slider-open");
    } else {
      document.body.classList.remove("details-slider-open");
    }
  }, [showDetailModal]);


  // Add these state variables to handle the date objects
  const [startDateObj, setStartDateObj] = useState(null);
  const [endDateObj, setEndDateObj] = useState(null);

  // Update startDateObj and endDateObj whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setStartDateObj(new Date(startDate));
    }
    if (endDate) {
      setEndDateObj(new Date(endDate));
    }
  }, [startDate, endDate]);



  useEffect(() => {
    let mounted = true;
    const loadTable = async () => {
      setTableLoading(true);
      try {
        await domainSquating(
          id,
          dispatch,
          page,
          category,
          subdomain,
          filterData,
          startDate,
          endDate,
          searchQuery,
          limit
        );
      } finally {
        if (mounted) {
          setTimeout(() => {
            if (mounted) setTableLoading(false);
          }, 1000);
        }
      }
    };

    loadTable();
    return () => {
      mounted = false;
    };
  }, [id, dispatch, page, category, subdomain, filterData, startDate, endDate, searchQuery, limit]);

  useEffect(() => {
    setTotalItems(totalCount);
  }, [totalCount]);

  useEffect(() => {
    domainSquatingTotal(id, dispatch);
  }, [id, dispatch]);

  useEffect(() => {
    domainSquatingExcel(id, dispatch);
  }, [id, dispatch]);

  useEffect(() => {
    domainSquatingDomain(id, dispatch);
  }, [id, dispatch]);

  let mapData = domains;

  let currentTableData = [];

  if (mapData && mapData.length > 0) {
    currentTableData = mapData;
  }

  const handleEditorChange = (even, editor) => {
    const data = editor.getData();
    setEditorContent(data); // Update the state with the new content
  };

  const takeDownValue = (res) => {
    let ip;
    res?.dnsDetails?.map((row) => {
      return Object.keys(row || {}).map((key) => {
        let record = row[key];
        if (record && record.length == 0) return false;
        if (key !== "dns_a") return false;
        record?.map((val) => {
          ip = val;
        });
      });
    });
    let originalWebsite = client.website;
    let domainName = res.lookalike;
    setStolenLocation(originalWebsite);
    setContenSource(domainName);
    setInfringingIp(ip);
    setRowId(res._id);
    setUserComment("");
    setUploadedFile(null);
    setFilePreview(null);
    // Clear file input
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    setTakeDownModal(true);
  };

  const submitTakeDownValue = async () => {
    if (userComment == "") {
      toastr.error("Error", "Comment cannot be empty.");
      return false;
    }

    try {
      setTakeDownModal(false);
      
      // Create FormData for file upload
      const formData = new FormData();
      formData.append('organisationId', id);
      formData.append('recordId', rowId);
      formData.append('userComment', userComment);
      formData.append('moduleName', 'lookalike');
      
      // Add file if uploaded
      if (uploadedFile) {
        formData.append('file', uploadedFile);
      }

      // Call takeDown API with FormData
      const response = await takeDown(formData, dispatch);
      
      // Refresh the listing after successful takedown request
      if (response && !response.error) {
        domainSquating(id, dispatch, page, category, subdomain, filterData, startDate, endDate, searchQuery, limit);
      }
      
      // Reset the form fields
      setUserComment("");
      setUploadedFile(null);
      setFilePreview(null);
      // Clear file input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } catch (error) {
      console.error("Error submitting takedown request:", error);
    }
  };

  // Handle file change  // Handle file change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check file size (10MB limit)
      if (file.size > 10 * 1024 * 1024) {
        toastr.error("Error", "File size must be less than 10MB");
        e.target.value = null;
        return;
      }
      
      setUploadedFile(file);
      
      // Create preview for images
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setFilePreview(reader.result);
        };
        reader.readAsDataURL(file);
      } else {
        setFilePreview(null);
      }
    }
  };

  const getScoreColor = (score) => {
    if (!score) return 'secondary';
    if (score >= 80) return 'danger';
    if (score >= 60) return 'warning';
    return 'success';
  };

  const riskBadge = (label, type = "secondary") => (
    <span className={`badge badge-${type} ml-2`}>{label}</span>
  );

  const formatDate = value => {
    if (!value) return "N/A";
    const date = new Date(value);
    if (!isValid(date)) return value;
    try {
      return format(date, "MMM dd, yyyy");
    } catch (err) {
      return value;
    }
  };

  const handleViewDetails = (domain) => {
    setSelectedDomain(domain);
    setShowWhois(false);
    setShowDetailModal(true);
  };

  // Download domain details report
  const handleDownloadDomainReport = () => {
    if (!selectedDomain) return;

    try {
      // Format date helper
      const formatDateForReport = (dateValue) => {
        if (!dateValue) return "N/A";
        try {
          const date = new Date(dateValue);
          if (isValid(date)) {
            return moment(date).format("YYYY-MM-DD");
          }
          return formatDate(dateValue);
        } catch (err) {
          return formatDate(dateValue);
        }
      };

      // Build text content
      let textContent = "=".repeat(80) + "\n";
      textContent += "LOOK-ALIKE DOMAIN DETAIL REPORT\n";
      textContent += "=".repeat(80) + "\n\n";
      textContent += `Generated on: ${moment().format("YYYY-MM-DD HH:mm:ss")}\n`;
      textContent += `Domain ID: ${selectedDomain._id || "N/A"}\n\n`;

      // Domain Summary Section
      textContent += "-".repeat(80) + "\n";
      textContent += "DOMAIN SUMMARY\n";
      textContent += "-".repeat(80) + "\n\n";
      textContent += `Original Domain: ${selectedDomain?.original || "N/A"}\n`;
      textContent += `Lookalike Domain: ${selectedDomain?.lookalike || "N/A"}\n`;
      textContent += `Detected On: ${formatDateForReport(selectedDomain?.createdAt)}\n`;
      textContent += `Risk Score: ${selectedDomain?.phishing_analysis?.phishing_score || "-"}\n`;
      textContent += `Status: ${selectedDomain?.is_malicious ? "Malicious" : "Clean"}\n\n`;

      // Phishing Risk Section
      if (selectedDomain?.phishing_analysis) {
        textContent += "-".repeat(80) + "\n";
        textContent += "PHISHING RISK ANALYSIS\n";
        textContent += "-".repeat(80) + "\n\n";
        
        if (selectedDomain.phishing_analysis.scoring_reason) {
          textContent += `Scoring Reason: ${typeof selectedDomain.phishing_analysis.scoring_reason === "object"
            ? JSON.stringify(selectedDomain.phishing_analysis.scoring_reason, null, 2)
            : selectedDomain.phishing_analysis.scoring_reason}\n\n`;
        }

        if (selectedDomain.phishing_analysis.conclusion) {
          textContent += `Conclusion: ${typeof selectedDomain.phishing_analysis.conclusion === "object"
            ? JSON.stringify(selectedDomain.phishing_analysis.conclusion, null, 2)
            : selectedDomain.phishing_analysis.conclusion}\n\n`;
        }

        if (selectedDomain.phishing_analysis.reasons_of_suspicion && selectedDomain.phishing_analysis.reasons_of_suspicion.length > 0) {
          textContent += "Reasons for Suspicion:\n";
          selectedDomain.phishing_analysis.reasons_of_suspicion.forEach((reason, idx) => {
            textContent += `  ${idx + 1}. ${typeof reason === "object" ? JSON.stringify(reason) : reason}\n`;
          });
          textContent += "\n";
        }
      }

      // WHOIS Information Section
      if (selectedDomain?.ownerDetails || selectedDomain?.whois) {
        textContent += "-".repeat(80) + "\n";
        textContent += "WHOIS INFORMATION\n";
        textContent += "-".repeat(80) + "\n\n";
        
        if (selectedDomain.ownerDetails) {
          Object.entries(selectedDomain.ownerDetails).forEach(([key, value]) => {
            const formattedKey = key.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase());
            if (Array.isArray(value)) {
              textContent += `${formattedKey}: ${value.join(", ")}\n`;
            } else if (typeof value === "object") {
              textContent += `${formattedKey}: ${JSON.stringify(value, null, 2)}\n`;
            } else {
              textContent += `${formattedKey}: ${value || "N/A"}\n`;
            }
          });
          textContent += "\n";
        }
      }

      // DNS Records Section
      if (selectedDomain?.dnsDetails && selectedDomain.dnsDetails.length > 0) {
        textContent += "-".repeat(80) + "\n";
        textContent += "DNS RECORDS\n";
        textContent += "-".repeat(80) + "\n\n";
        selectedDomain.dnsDetails.forEach((dns, idx) => {
          textContent += `Record ${idx + 1}:\n`;
          Object.entries(dns).forEach(([key, value]) => {
            textContent += `  ${key}: ${JSON.stringify(value)}\n`;
          });
          textContent += "\n";
        });
      }

      // IP Information Section
      if (selectedDomain?.ipdetails && selectedDomain.ipdetails.length > 0) {
        textContent += "-".repeat(80) + "\n";
        textContent += "IP INFORMATION\n";
        textContent += "-".repeat(80) + "\n\n";
        selectedDomain.ipdetails.filter(ip => ip && ip.ip).forEach((ip, idx) => {
          textContent += `IP ${idx + 1}: ${ip.ip}\n`;
          textContent += `  Status: ${ip.is_malicious ? "Malicious" : "Clean"}\n`;
          if (ip.reputation) {
            textContent += `  Reputation: ${typeof ip.reputation === "object" ? JSON.stringify(ip.reputation) : ip.reputation}\n`;
          }
          if (ip.pulse_count) {
            textContent += `  Pulse Count: ${typeof ip.pulse_count === "object" ? JSON.stringify(ip.pulse_count) : ip.pulse_count}\n`;
          }
          textContent += "\n";
        });
      }

      textContent += "\n" + "=".repeat(80) + "\n";
      textContent += "End of Report\n";
      textContent += "=".repeat(80) + "\n";

      // Create and download text file
      const blob = new Blob([textContent], { type: "text/plain" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      const domainName = selectedDomain?.lookalike || selectedDomain?.original || "domain";
      const sanitizedDomain = domainName.replace(/[^a-zA-Z0-9.-]/g, "_");
      const fileName = `Lookalike_Domain_${sanitizedDomain}_${selectedDomain._id.substring(0, 10)}_${moment().format("YYYY-MM-DD")}.txt`;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toastr.success("Success", "Domain details downloaded successfully");
    } catch (error) {
      console.log(error);
      toastr.error("Error", "Failed to download domain details");
    }
  };

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }


  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `${API_URL}/organisations/${id}/domainsquatting/excel`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}Look-alike domains.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  const dnsKeyName = (val) => {
    if (val == "dns_a") return "A Record";
    else if (val == "dns_ns") return "NS Record";
    else if (val == "dns_mx") return "MX Record";
    else if (val == "dns_aaa") return "AAA Record";
  };

  const reScan = () => {
    let data = {
      "moduleName": ["lookaLike"]
    }
    rescanSingle(id, data)
  }


  const series = [
    totalLookLikeCount?.totalLookalikeDomains, totalLookLikeCount?.totalLookalikeDomainsRegisteredInLast30Days, totalLookLikeCount?.totalLookalikeDomainsRegisteredInLast60Days
  ];

  const labels = ["Active Domains", "Registered in last 30 days", "Registered in last 60 days"];


  // Add these new state variables
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [tempStartDate, setTempStartDate] = useState(null);
  const [tempEndDate, setTempEndDate] = useState(null);

  // Update tempStartDate and tempEndDate whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setTempStartDate(new Date(startDate));
    }
    if (endDate) {
      setTempEndDate(new Date(endDate));
    }
  }, [startDate, endDate]);

  // Add this new function to format the displayed date range
  const formatDateRange = () => {
    if (startDate && endDate) {
      return `Selected date: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''} to ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    } else if (startDate) {
      return `From: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''}`;
    } else if (endDate) {
      return `Till: ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    }
    return "Select date range"; // Default placeholder text
  };

  // Add this function to handle applying the selected date range
  const applyDateRange = () => {
    if (tempStartDate) {
      setStartDate(format(tempStartDate, 'yyyy-MM-dd'));
    } else {
      setStartDate('');
    }

    if (tempEndDate) {
      setEndDate(format(tempEndDate, 'yyyy-MM-dd'));
    } else {
      setEndDate('');
    }

    setDatePickerOpen(false);
    setPage(1);
  };

  // Update the cancelDateSelection function to clear all dates
  const cancelDateSelection = () => {
    // Clear all date states when cancel is clicked
    setTempStartDate(null);
    setTempEndDate(null);
    setStartDate('');
    setEndDate('');
    setStartDateObj(null);
    setEndDateObj(null);
    setDatePickerOpen(false);
  };

  // Function to handle adding a new lookalike domain
  const handleAddLookalikeDomain = () => {
    if (!newLookalikeDomain.lookalike || !newLookalikeDomain.original) {
      toastr.error("Error", "Original and lookalike domains are required.");
      return;
    }

    const data = {
      ...newLookalikeDomain,
      organisationId: id
    };

    addLookalikeDomain(data, dispatch)
    resetAddLookalikeForm();
    setIsAddLookalikeModal(false);
  };

  // Function to reset the form
  const resetAddLookalikeForm = () => {
    setNewLookalikeDomain({
      organisationId: "",
      lookalike: "",
      original: "",
      fuzzer: "typo"
    });
  };

  // Function to open the add lookalike modal
  const openAddLookalikeModal = () => {
    resetAddLookalikeForm();
    setIsAddLookalikeModal(true);
  };

  // Function to handle viewing ticket details
  const handleViewTicketDetails = (domain) => {
    setSelectedTicket(domain);
    setIsTicketDetailsModal(true);
  };

  return (
    <>
      <div className="container-fluid">
        <AccessPage />
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-4 col-sm-12">
              <h1 className="welcome-text">Look-alike Domains</h1>
              <nav aria-label="breadcrumb" className="mt-1">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    {vendorId ? (
                      <Link to="/vendor" onClick={() => sessionStorage.clear()}>
                        Forest View
                      </Link>
                    ) : (
                      <Link to="/" className="welcome-textSmall">Home</Link>
                    )}
                  </li>
                  {vendorName && (
                    <li className="breadcrumb-item">
                      <Link to={`/dashboard/vendor/${vendorId}`}>{vendorName}</Link>
                    </li>
                  )}
                  <li className="breadcrumb-item active">Look-alike Domains</li>
                </ol>
              </nav>
            </div>
            <div className="col-md-8 col-sm-12 hidden-xs d-flex justify-content-end align-items-center">
              <span>
                {auth?.accessLevel == "Admin" && (
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      reScan();
                    }}
                    style={{ color: "black", fontWeight: "bold" }}
                    className="btn btn-primary mr-1"
                  >
                    Rescan
                  </a>
                )}
              </span>
              <span className="mr-2">
                 <a
                      onClick={(e) => {
                        e.preventDefault();
                        setIsRecommendationModal(true);
                      }}
                      href="#"
                      className="btn btn-sm btn-primary mr-1"
                      style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
                    >
                      <i className="fa fa-lightbulb-o" style={{ fontSize: "14px" }}></i>
                      Recommendation
                    </a>
              </span>
              <span>
                {client?.subscriptionType != "trial" && mapData?.length !== 0 && (
                  <>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        downloadFile();
                      }}
                      href="/add-report"
                      className="btn btn-sm btn-primary mr-1 download-report"
                    >
                      Download Details
                    </a>
                  </>
                )}
              </span>
              
            </div>
          </div>


          {typeof scanCompleted !== "undefined" && !scanCompleted && (
            <div className="card border-success">
              <ScanMessage />
            </div>
          )}

        </div>
        <div className="row clearfix">
          <div className="col-lg-4 col-md-12 col-sm-12">
            <div className="card RecordFoundCard">
              <div className="body" style={{ minHeight: "460px" }}>
                <h6 className="mb-3 welcome-textSmall">Records Found</h6>
                <div className="d-flex mb-3 justify-content-center">
                  {series && series?.length > 0 && <PieChart series={series} label={labels} />}
                </div>
                <div className="mb-4 mt-3">
                  <label
                    className="d-block"
                    style={{ cursor: "pointer" }}
                    onClick={() => setfilterData("active")}
                  >
                    <span className="greenShadow"></span>
                    Active Domains
                    <span className="float-right">
                      {totalLookLikeCount?.totalLookalikeDomains}
                    </span>
                  </label>
                </div>
                <div className="mb-4">
                  <label
                    className="d-block"
                    style={{ cursor: "pointer" }}
                    onClick={() => setfilterData("registered-in-last-30-days")}
                  >
                    <span className="yellowShadow"></span>
                    Registered in last 30 days
                    <span className="float-right">
                      {totalLookLikeCount?.totalLookalikeDomainsRegisteredInLast30Days}
                    </span>
                  </label>
                </div>
                <div className="mb-4">
                  <label
                    className="d-block"
                    style={{ cursor: "pointer" }}
                    onClick={() => setfilterData("60days")}
                  >
                    <span className="redShadow"></span>
                    Registered in last 60 days{" "}
                    <span className="float-right">
                      {totalLookLikeCount?.totalLookalikeDomainsRegisteredInLast60Days}
                    </span>
                  </label>
                </div>

                {client?.subscriptionType == "trial" && (
                  <div className="card border-warning">
                    <TrialComponent />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-lg-8 col-md-12 col-sm-12">
            <div className="card">
              <div className="body" style={{ minHeight: "460px" }}>
                <h6 className="welcome-textSmall">Previous scan details</h6>

                <div id="University_Survey" className="flot-chart">
                  {/* <SurveyChart /> */}
                  {scanDetails && (
                    <BasicLineColumn
                      dates={scanDetails?.dates}
                      ipArray={ipArray}
                      color={["#08283f"]}
                      yAxis="Similar Domains found"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-lg-12 col-md-12">
            <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
              <li className="nav-item">
                <a
                  className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
                    }`}
                  onClick={() => {
                    setFirstLoad(true);
                    setCategory("all");
                    setPage(1);
                    setSubdomain("all");
                    setfilterData("all");
                    setSelectedIds([]);
                  }}
                >
                  Current
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
                    }`}
                  onClick={() => {
                    setFirstLoad(true);
                    setCategory("risk-accepted");
                    setPage(1);
                    setSubdomain("all");
                    setfilterData("all");
                    setSelectedIds([]);
                  }}
                >
                  Risk Accepted
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""
                    }`}
                  onClick={() => {
                    setFirstLoad(true);
                    setCategory("false-positive");
                    setPage(1);
                    setSubdomain("all");
                    setfilterData("all");
                    setSelectedIds([]);
                  }}
                >
                  False Positive
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
                    }`}
                  onClick={() => {
                    setFirstLoad(true);
                    setCategory("remidiated");
                    setPage(1);
                    setSubdomain("all");
                    setfilterData("all");
                    setSelectedIds([]);
                  }}
                >
                  Remediated
                </a>
              </li>
            </ul>
            <div className="card card_tableBox">
              <div className="body">
                <div className="row clearfix">
                  <div className="col-sm-3 mb-2">
                    <div className="date-picker-container">
                      <div className="date-range-input">
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Select date range"
                          value={formatDateRange()}
                          onClick={() => setDatePickerOpen(true)}
                          readOnly
                        />
                        <span className="calendar-icon">
                          <i className="fa fa-calendar" aria-hidden="true"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-3 mb-2">
                    <select
                      className="custom-select custom-select-sm form-control form-control-sm"
                      value={filterData}
                      onChange={(e) => setfilterData(e.target.value)}
                    >
                      <option value="all">All</option>
                      <option value="active">Active</option>
                      <option value="registered-in-last-30-days">
                        Registered in 30 days
                      </option>
                      <option value="registered-in-last-60-days">
                        Registered in 60 days
                      </option>
                    </select>
                  </div>

                  <div className="col-sm-3 mb-2">
                    <div className="searchBoxInput p-0">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Search domains..."
                        value={searchQuery}
                        onChange={(e) => {
                          setSearchQuery(e.target.value);
                          setPage(1);
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-sm-3 mb-2">
                    <select
                      className="custom-select custom-select-sm form-control form-control-sm"
                      value={subdomain}
                      onChange={(e) => setSubdomain(e.target.value)}
                    >
                      <option value="all">All Domain</option>
                      {subDomainList?.map((row, index) => {
                        return <option value={row}>{row?.toUpperCase()}</option>;
                      })}
                    </select>
                  </div>




                  <div className="col-lg-6 d-flex mb-2">
                    {selectedIds.length > 1 && userPermission && category === "all" && (
                      <Box sx={{ width: 160 }}>
                        <FormControl fullWidth>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedValue}
                            onChange={(event) => {
                              setAction(event.target.value);
                              snooze("", event.target.value);
                            }}
                          >
                            <MenuItem value="pleaseSelect">
                              Snooze Options
                            </MenuItem>
                            <MenuItem
                              value="riskAccepted"
                              onClick={() => {
                                addModal();
                              }}
                            >
                              Risk Accepted
                            </MenuItem>
                            <MenuItem
                              value="markAsFalsePositive"
                              onClick={() => {
                                addModal();
                              }}
                            >
                              False Positive
                            </MenuItem>
                            <MenuItem value="markAsRemidiated">
                              Remediated
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    )}
                    {selectedIds.length > 1 && userPermission && category === "all" && (
                      <button
                        className="btn btn-danger btn-sm ml-2 mb-2"
                        onClick={() => setBulkTakeDownModal(true)}
                        title="Request takedown for selected domains"
                      >
                        <i className="fa fa-arrow-down mr-1"></i>
                        Bulk Takedown Request
                      </button>
                    )}
                    {selectedIds.length > 1 && userPermission &&
                      (category == "false-positive" ||
                        category == "risk-accepted") && (
                        <button
                          className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                          onClick={() => Unsnoozed("")}
                        >
                          Unsnooze
                        </button>
                      )}
                  </div>
                </div>
                <div className="table-responsive">
                  <table className="table table-custom spacing5 mb-0">
                    <thead>
                      <tr>
                        {auth?.accessLevel !== "Threat Analyst" &&
                          (category === "all" || category === "risk-accepted" || category === "false-positive") && (
                            <th>
                              <input
                                type="checkbox"
                                checked={selectedIds.length > 0 && multiCheckTrue}
                                onChange={() => multicheck(currentTableData)}
                                className="checkUnCheck"
                              />
                            </th>
                          )}
                        <th>Domain</th>
                        <th>Malicious IP</th>
                        <th>Risk Score</th>
                        <th>Created Date</th>
                        <th>Take Down Status</th>
                        <th>Details</th>
                        <th>Actions</th>
                        {category !== "all" && <th>Action Note</th>}
                      </tr>
                    </thead>
                    <tbody style={{ position: 'relative' }}>
                      {tableLoading && (
                        <tr style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 10 }}>
                          <td
                            colSpan={
                              8 +
                              (category !== "all" ? 1 : 0) +
                              (auth?.accessLevel !== "Threat Analyst" &&
                                (category === "all" || category === "risk-accepted" || category === "false-positive")
                                ? 1
                                : 0)
                            }
                            style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backgroundColor: 'rgba(255, 255, 255, 0.8)',
                              minHeight: '200px'
                            }}
                          >
                            <div className="spinner-border text-primary" role="status">
                              <span className="sr-only">Loading...</span>
                            </div>
                          </td>
                        </tr>
                      )}
                      {domains?.map((domain, index) => (
                          <tr key={index}>
                            {auth?.accessLevel !== "Threat Analyst" &&
                              (category === "all" || category === "risk-accepted" || category === "false-positive") && (
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={selectedIds.includes(domain?._id)}
                                    onChange={() => singleClick(domain?._id)}
                                    className="checkUnCheck"
                                  />
                                </td>
                              )}
                            <td>
                              <span className="text-primary">{domain?.original}</span>
                              <i className="fas fa-arrow-right mx-2"></i>
                              <span className={domain?.is_malicious ? 'text-danger' : 'text-success'}>
                                {domain?.lookalike}
                              </span>
                            </td>
                            <td>
                              <span className={`badge p-0 badge-${domain?.is_malicious ? 'danger' : 'success'}`}>
                                {domain?.is_malicious ? 'Malicious' : 'Clean'}
                              </span>
                            </td>
                            <td>
                              <div className={`badge bg-${getScoreColor(domain?.phishing_analysis?.phishing_score)}`}>
                                {domain?.phishing_analysis?.phishing_score || 'N/A'}
                              </div>
                            </td>
                            <td>{new Date(domain?.createdAt).toLocaleDateString()}</td>
                            <td>
                              {domain?.ticketExists ? (
                                <div>
                                  <span className={`badge badge-${domain?.ticketStatus === 'completed' ? 'success' : domain?.ticketStatus === 'inProgress' ? 'warning' : 'info'}`}>
                                    {domain?.ticketStatus === 'completed' ? 'Completed' : 
                                     domain?.ticketStatus === 'inProgress' ? 'In Progress' : 
                                     domain?.ticketStatus || 'Submitted'}
                                  </span>
                                  {domain?.requestStatus && (
                                    <div className="mt-1 small text-muted">
                                      {domain.requestStatus}
                                    </div>
                                  )}
                                  {domain?.userComment && (
                                    <div className="mt-1 small text-muted">
                                      <strong>Comment:</strong> {domain.userComment}
                                    </div>
                                  )}
                                  <div className="mt-1">
                                    <button
                                      className="btn btn-sm btn-outline-info"
                                      onClick={() => handleViewTicketDetails(domain)}
                                      title="View Ticket Details"
                                    >
                                      <i className="fa fa-ticket mr-1"></i>
                                      Ticket Details
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                <Link
                                  to="#"
                                  className="text-danger"
                                  onClick={() => takeDownValue(domain)}
                                >
                                  Request Takedown
                                  <i className="fa fa-arrow-down ml-2"></i>
                                </Link>
                              )}
                            </td>
                            <td>
                              <button
                                className="btn btn-sm"
                                onClick={() => domain && handleViewDetails(domain)}
                                style={{
                                  backgroundColor: "#17a2b8",
                                  borderColor: "#17a2b8",
                                  color: "#fff",
                                  borderRadius: "4px",
                                  padding: "4px 12px",
                                  transition: "all 0.3s ease",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "6px"
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.backgroundColor = "#138496";
                                  e.target.style.borderColor = "#117a8b";
                                  e.target.style.transform = "translateY(-1px)";
                                  e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.2)";
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.backgroundColor = "#17a2b8";
                                  e.target.style.borderColor = "#17a2b8";
                                  e.target.style.transform = "translateY(0)";
                                  e.target.style.boxShadow = "none";
                                }}
                              >
                                <i className="fa fa-info-circle" style={{ fontSize: "14px" }}></i>
                                <span className="details-slider-action-btn-text">Details</span>
                              </button>
                            </td>
                            {category !== "all" && <td style={{ whiteSpace: "unset" }}>{domain?.actionNote ? domain.actionNote : "N/A"}</td>}
                            <td>
                              {domain?.remediationPending == true ? (
                                <span>Retest in progress</span>
                              ) : (
                                <>
                                {auth?.accessLevel != "Threat Analyst" && userPermission && category === "all" && (
                                  <Box sx={{ width: 160 }}>
                                    <FormControl fullWidth>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={selectedValue}
                                        onChange={(event) => {
                                          setAction(event.target.value);
                                          snooze(
                                            domain?._id
                                          );
                                        }}
                                      >
                                        <MenuItem value="pleaseSelect">
                                          Snooze Options
                                        </MenuItem>
                                        <MenuItem
                                          value="riskAccepted"
                                          onClick={() => {
                                            addModal();
                                            setLookalikeAppId([domain?._id]);
                                          }}
                                        >
                                          Risk Accepted
                                        </MenuItem>
                                        <MenuItem
                                          value="markAsFalsePositive"
                                          onClick={() => {
                                            addModal();
                                            setLookalikeAppId([domain?._id]);
                                          }}
                                        >
                                          False Positive
                                        </MenuItem>
                                        <MenuItem value="markAsRemidiated">
                                          Remediated
                                        </MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Box>
                                )}
                                </>
                              )}
                              {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "risk-accepted" ||
                                category === "false-positive") && (
                                  <button
                                    className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                    onClick={() =>
                                      Unsnoozed(
                                        domain?._id
                                      )
                                    }
                                  >
                                    Unsnooze
                                  </button>
                                )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="dataTables_paginate">
                    {totalItems > 0 && (
                      <Pagination
                        className="pagination-bar"
                        currentPage={page}
                        totalCount={totalItems}
                        pageSize={limit}
                        onPageChange={(page) => setPage(page)}
                      />
                    )}
                  </div>
                  {totalItems > 10 && (
                    <select
                      value={limit}
                      onChange={(e) => {
                        setLimit(e.target.value)
                        setPage(1);
                      }}
                      className="form-control limitSelectBox"
                    >
                      <option value={10}>10 per page</option>
                      <option value={25}>25 per page</option>
                      <option value={50}>50 per page</option>
                      <option value={100}>100 per page</option>
                    </select>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade Form-Wizard-modal ${isTakeDownModal ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Submit Take Down Request
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setTakeDownModal(false);
                  setUserComment("");
                  setUploadedFile(null);
                  setFilePreview(null);
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row clearfix">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="card card_ck">
                    <div className="body">
                      <div className="col-md-12">
                        <label className="col-lg-12 col-md-12"><strong>Comment</strong> <span className="text-danger">*</span></label>
                        <div className="form-group col-lg-12 col-md-12">
                          <textarea
                            onChange={(e) => setUserComment(e.target.value)}
                            value={userComment}
                            className="form-control"
                            rows="4"
                            placeholder="Please provide details about the takedown request..."
                            required
                          ></textarea>
                        </div>
                      </div>
                      
                      <div className="col-md-12 mt-3">
                        <label className="col-lg-12 col-md-12"><strong>Upload Supporting File/Screenshot</strong> (Optional)</label>
                        <div className="form-group col-lg-12 col-md-12">
                          <input
                            ref={fileInputRef}
                            type="file"
                            className="form-control"
                            accept="image/*,.pdf,.doc,.docx"
                            onChange={handleFileChange}
                          />
                          <small className="form-text text-muted">
                            Supported formats: Images, PDF, DOC, DOCX (Max 10MB)
                          </small>
                        </div>
                      </div>

                      {filePreview && (
                        <div className="col-md-12 mt-2">
                          <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                              <span>File Preview</span>
                              <button
                                type="button"
                                className="btn btn-sm btn-danger"
                                onClick={() => {
                                  setUploadedFile(null);
                                  setFilePreview(null);
                                  // Clear file input
                                  if (fileInputRef.current) {
                                    fileInputRef.current.value = '';
                                  }
                                }}
                              >
                                <i className="fa fa-times"></i> Remove
                              </button>
                            </div>
                            <div className="card-body text-center">
                              <img
                                src={filePreview}
                                alt="Preview"
                                className="image-clickable"
                                style={{ maxWidth: '100%', maxHeight: '300px', objectFit: 'contain' }}
                                onClick={() => {
                                  setImageModalSrc(filePreview);
                                  setImageModalOpen(true);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {uploadedFile && !filePreview && (
                        <div className="col-md-12 mt-2">
                          <div className="alert alert-info d-flex justify-content-between align-items-center">
                            <span>
                              <i className="fa fa-file mr-2"></i>
                              {uploadedFile.name} ({(uploadedFile.size / 1024).toFixed(2)} KB)
                            </span>
                            <button
                              type="button"
                              className="btn btn-sm btn-danger"
                              onClick={() => {
                                setUploadedFile(null);
                                setFilePreview(null);
                                // Clear file input
                                if (fileInputRef.current) {
                                  fileInputRef.current.value = '';
                                }
                              }}
                            >
                              <i className="fa fa-times"></i> Remove
                            </button>
                          </div>
                        </div>
                      )}
                      
                      <div className="col-lg-12 col-md-12">
                        <button
                          className="btn btn-primary btn-sm mr-1 pull-right"
                          style={{ marginTop: "10px" }}
                          onClick={() => submitTakeDownValue()}
                          disabled={!userComment.trim()}
                        >
                          <i className="fa fa-paper-plane mr-2"></i>
                          Submit Request
                        </button>
                        <button
                          className="btn btn-default btn-sm pull-right"
                          style={{ marginTop: "10px", marginRight: "10px" }}
                          onClick={() => {
                            setTakeDownModal(false);
                            setUserComment("");
                            setUploadedFile(null);
                            setFilePreview(null);
                            // Clear file input
                            if (fileInputRef.current) {
                              fileInputRef.current.value = '';
                            }
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`modal fade Form-Wizard-modal ${isBulkTakeDownModal ? "d-block show" : ""}`}>
        <div className="modal-dialog modal-lg" id="bulkTakedownModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="bulkTakedownModalLabel">
                Bulk Takedown Request 
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setBulkTakeDownModal(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row clearfix">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="card card_ck">
                    <div className="body">
                      <div className="col-md-12">
                        <label className="col-lg-12 col-md-12">Comment <span className="text-danger">*</span></label>
                        <div className="form-group col-lg-12 col-md-12">
                          <textarea
                            onChange={(e) => setBulkTakeDownComment(e.target.value)}
                            value={bulkTakeDownComment}
                            className="form-control"
                            rows="3"
                            placeholder="Enter comment for all selected items..."
                            required
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 takeDownButtonBox">
                        <button
                          className="btn btn-default btn-sm mr-1 pull-right"
                          style={{ marginTop: "10px" }}
                          onClick={() => {
                            setBulkTakeDownModal(false);
                            setBulkTakeDownComment("");
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-primary btn-sm mr-1 pull-right"
                          style={{ marginTop: "10px" }}
                          onClick={() => submitBulkTakeDown()}
                        >
                          Submit Bulk Takedown
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade Form-Wizard-modal ${isModalTable === "Form Wizard modal" ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {action == "markAsFalsePositive"
                  ? "Mark As False Positive"
                  : "Risk Accepted"}
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setModalTable("");
                  setActionNote("");
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page modal_mob">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="card">
                  <div className="row clearfix">
                    <div className="col-md-12">
                      <label className="col-lg-6 col-md-12">Snooze for</label>
                      <div className="form-group ol-lg-12 col-md-12">
                        <select
                          className="custom-select custom-select-sm form-control form-control-sm"
                          onChange={(e) => setForValue(e.target.value)}
                        >
                          <option value="forever">Forever</option>
                          <option value="3 months">3 Months</option>
                          <option value="6 months">6 Months</option>
                          <option value="12 months">12 Months</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <label className="col-lg-12 col-md-12">Detail</label>
                      <div className="form-group col-lg-12 col-md-12">
                        <textarea
                          onChange={(e) => setActionNote(e.target.value)}
                          value={actionNote}
                          className="form-control"
                          rows="3"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div
                      className="col-lg-12 col-md-12"
                      style={{ marginRight: "28px" }}
                    >
                      <button
                        type="button"
                        style={{ color: "black", fontWeight: "bold" }}
                        onClick={submit}
                        className="btn btn-round btn-primary mr-1 pull-right"
                      >
                        Submit
                      </button>
                      &nbsp;&nbsp;
                      <button
                        type="button"
                        onClick={() => {
                          setModalTable("");
                          setActionNote("");
                        }}
                        className="btn btn-round btn-default pull-right"
                        style={{ marginRight: "10px" }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {selectedDomain && (
        <>
          <div
            className={`details-slider-overlay ${showDetailModal ? "show" : ""}`}
            onClick={() => {
              setShowDetailModal(false);
              setSelectedDomain(null);
            }}
          ></div>
          <div className={`details-slider-panel ${showDetailModal ? "open" : ""}`}>
            <div className="details-slider-content">
              <div className="details-slider-header">
                <h5 style={{ color: "white", margin: 0, display: "flex", alignItems: "center", gap: "8px" }}>
                  <i className="fa fa-globe"></i>
                  Look-alike Domain Details
                  {selectedDomain?.lookalike && (
                    <span className="text-white" style={{ fontSize: "0.85em", opacity: 0.9,}}>
                      - {selectedDomain.lookalike}
                    </span>
                  )}
                  {selectedDomain?._id && (
                    <span className="ml-2 text-white" style={{ fontSize: "0.8em", opacity: 0.85,}}>
                      #{selectedDomain._id.substring(0, 8)}...
                    </span>
                  )}
                </h5>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <button
                    type="button"
                    className="details-slider-action-btn"
                    onClick={handleDownloadDomainReport}
                    title="Download Domain Report"
                  >
                    <i className="fa fa-download"></i>
                    <span className="details-slider-action-btn-text">Download</span>
                  </button>
                  <button
                    type="button"
                    className="details-slider-close"
                    aria-label="Close"
                    onClick={() => {
                      setShowDetailModal(false);
                      setSelectedDomain(null);
                    }}
                  >
                    <i className="fa fa-times"></i>
                  </button>
                </div>
              </div>
              <div className="details-slider-body">
                <div className="details-section">
                  <div className="details-section-title">
                    <i className="fa fa-globe"></i>
                    Domain Summary
                  </div>
                  <div className="details-info-item">
                    <div className="details-info-label">Original Domain</div>
                    <div className="details-info-value text-primary font-weight-bold">{selectedDomain?.original || "N/A"}</div>
                  </div>
                  <div className="details-info-item">
                    <div className="details-info-label">Lookalike Domain</div>
                    <div className="details-info-value">
                      <span className={selectedDomain?.is_malicious ? "text-danger" : "text-success"}>
                        {selectedDomain?.lookalike || "N/A"}
                      </span>
                      {selectedDomain?.is_malicious
                        ? riskBadge("Malicious", "danger")
                        : riskBadge("Clean", "success")}
                    </div>
                  </div>
                  <div className="details-info-item">
                    <div className="details-info-label">Detected On</div>
                    <div className="details-info-value">{formatDate(selectedDomain?.createdAt)}</div>
                  </div>
                     <div className="details-info-item">
                    <div className="details-info-label">Risk Score</div>
                    <div className="details-info-value">{selectedDomain?.phishing_analysis?.phishing_score || "-"}</div>
                  </div>
                  {selectedDomain?.phishing_analysis?.conclusion && (
                    <div className="details-info-item">
                      <div className="details-info-label">Conclusion</div>
                      <div className="details-info-value">
                        {typeof selectedDomain?.phishing_analysis?.conclusion === "object"
                          ? JSON.stringify(selectedDomain?.phishing_analysis?.conclusion)
                          : selectedDomain?.phishing_analysis?.conclusion}
                      </div>
                    </div>
                  )}
                </div>

                <div className="details-section">
                  <div className="details-section-title">
                    <i className="fa fa-shield-alt"></i>
                    Phishing Risk
                  </div>
                  <div className="d-flex align-items-center">
                    
                    <div className="ml-3">
                      <div className="font-weight-bold">Risk Score</div>
                      <div>
                        {selectedDomain?.phishing_analysis?.scoring_reason &&
                          (typeof selectedDomain?.phishing_analysis?.scoring_reason === "object"
                            ? JSON.stringify(selectedDomain?.phishing_analysis?.scoring_reason)
                            : selectedDomain?.phishing_analysis?.scoring_reason)}
                      </div>
                    </div>
                  </div>
                  {selectedDomain?.phishing_analysis?.reasons_of_suspicion?.length > 0 && (
                    <div className="mt-3">
                      <div className="font-weight-bold mb-2">Reasons for Suspicion</div>
                      <ul className="list-unstyled mb-0">
                        {selectedDomain?.phishing_analysis?.reasons_of_suspicion.map((reason, idx) => (
                          <li key={idx} className="mb-2">
                            <i className="fas fa-exclamation-triangle text-warning mr-2"></i>
                            {typeof reason === "object" ? JSON.stringify(reason) : reason}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>

                {(selectedDomain?.ownerDetails || selectedDomain?.whois) && (
                  <div className="details-section">
                    <div className="details-section-title">
                      <i className="fa fa-id-card"></i>
                      WHOIS Information
                      <button
                        className="btn btn-sm btn-outline-primary ml-auto"
                        onClick={() => setShowWhois(prev => !prev)}
                      >
                        {showWhois ? "Hide WHOIS" : "Show WHOIS"}
                      </button>
                    </div>
                    {showWhois && (
                      <div className="table-responsive">
                        <table className="table table-sm table-striped mb-0">
                          <tbody>
                            {Object.entries(selectedDomain?.ownerDetails || {}).map(([key, value]) => (
                              <tr key={key}>
                                <td className="font-weight-bold" style={{ width: "200px" }}>
                                  {key.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase())}
                                </td>
                                <td>
                                  {Array.isArray(value)
                                    ? value.join(", ")
                                    : typeof value === "object"
                                      ? JSON.stringify(value, null, 2)
                                      : value}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                )}

                {selectedDomain?.dnsDetails?.length > 0 && (
                  <div className="details-section">
                    <div className="details-section-title">
                      <i className="fa fa-server"></i>
                      DNS Records
                    </div>
                    <div className="table-responsive">
                      <table className="table table-sm mb-0">
                        <tbody>
                          {selectedDomain.dnsDetails.map((dns, idx) => (
                            <tr key={idx}>
                              {Object.entries(dns).map(([key, value]) => (
                                <td key={key}>
                                  <strong>{key}:</strong> {JSON.stringify(value)}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {selectedDomain?.ipdetails?.length > 0 && (
                  <div className="details-section">
                    <div className="details-section-title">
                      <i className="fa fa-network-wired"></i>
                      IP Information
                    </div>
                    <div className="row">
                      {selectedDomain.ipdetails.filter(ip => ip && ip.ip).map((ip, idx) => (
                        <div key={idx} className="col-md-6">
                          <div className="card">
                            <div className="card-body p-3">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <span>{ip.ip}</span>
                                {riskBadge(ip.is_malicious ? "Malicious" : "Clean", ip.is_malicious ? "danger" : "success")}
                              </div>
                              <div className="small text-muted mb-1">Reputation</div>
                              <div className="mb-2">{typeof ip.reputation === "object" ? JSON.stringify(ip.reputation) : ip.reputation}</div>
                              <div className="small text-muted mb-1">Pulse Count</div>
                              <div>{typeof ip.pulse_count === "object" ? JSON.stringify(ip.pulse_count) : ip.pulse_count}</div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {selectedDomain?.phishing_analysis?.suspicious_website_analysis?.fullpage_screenshot_url && (
                  <div className="details-section">
                    <div className="details-section-title">
                      <i className="fa fa-image"></i>
                      Website Screenshot
                    </div>
                    <div className="screenshot-container position-relative" style={{ minHeight: "auto" }}>
                      {loadingScreenshots[selectedDomain._id] && (
                        <div className="screenshot-loader position-absolute w-100 h-100 d-flex align-items-center justify-content-center">
                          <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      )}
                      <img
                        src={selectedDomain.phishing_analysis.suspicious_website_analysis.fullpage_screenshot_url}
                        alt="Website Screenshot"
                        className="img-fluid rounded image-clickable"
                        style={{
                          maxHeight: "400px",
                          width: "100%",
                          objectFit: "contain",
                          opacity: loadingScreenshots[selectedDomain._id] ? "0" : "1",
                          transition: "opacity 0.3s ease-in-out",
                        }}
                        onClick={() => {
                          setImageModalSrc(selectedDomain.phishing_analysis.suspicious_website_analysis.fullpage_screenshot_url);
                          setImageModalOpen(true);
                        }}
                        onLoadStart={() => setLoadingScreenshots(prev => ({ ...prev, [selectedDomain._id]: true }))}
                        onLoad={() => setLoadingScreenshots(prev => ({ ...prev, [selectedDomain._id]: false }))}
                        onError={(e) => {
                          setLoadingScreenshots(prev => ({ ...prev, [selectedDomain._id]: false }));
                          e.target.style.display = "none";
                          const errorDiv = document.createElement("div");
                          errorDiv.className = "text-center p-4";
                          errorDiv.innerHTML = `
                                <i class="fas fa-exclamation-circle mb-2" style="font-size: 2rem; color: #2e2a74;"></i>
                                <p class="mb-0">Screenshot currently unavailable</p>
                                <p class="mb-0">The website may be offline or blocking access</p>
                              `;
                          e.target.parentNode.appendChild(errorDiv);
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}

      {/* Add Lookalike Domain Modal */}
      <div className={`modal fade Form-Wizard-modal ${isAddLookalikeModal ? "d-block show" : ""}`}>
        <div className="modal-dialog modal-lg" id="addLookalikeModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Lookalike Domain</h5>
              <button
                type="button"
                className="close"
                onClick={() => setIsAddLookalikeModal(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row clearfix">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="card card_ck">
                    <div className="body">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Original Domain</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="example.com"
                              value={newLookalikeDomain.original}
                              onChange={(e) => setNewLookalikeDomain({
                                ...newLookalikeDomain,
                                original: e.target.value
                              })}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Lookalike Domain</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="exampie.com"
                              value={newLookalikeDomain.lookalike}
                              onChange={(e) => setNewLookalikeDomain({
                                ...newLookalikeDomain,
                                lookalike: e.target.value
                              })}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Fuzzer Type</label>
                            <select
                              className="form-control"
                              value={newLookalikeDomain.fuzzer}
                              onChange={(e) => setNewLookalikeDomain({
                                ...newLookalikeDomain,
                                fuzzer: e.target.value
                              })}
                            >
                              {fuzzerOptions.map((option) => (
                                <option key={option} value={option}>
                                  {option.charAt(0).toUpperCase() + option.slice(1)}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-lg-12 col-md-12 text-right">
                          <button
                            className="btn btn-default mr-2"
                            onClick={() => setIsAddLookalikeModal(false)}
                          >
                            Cancel
                          </button>
                          <button
                            className="btn btn-primary"
                            onClick={handleAddLookalikeDomain}
                          >
                            Add Domain
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {datePickerOpen && (
          <div className="date-range-overlay" onClick={() => setDatePickerOpen(false)}>
            <div className="date-range-picker-popup" onClick={(e) => e.stopPropagation()}>
              <div className="date-range-picker-header">
                {tempStartDate && tempEndDate
                  ? `Selected date: ${format(tempStartDate, 'MM/dd/yyyy')} to ${format(tempEndDate, 'MM/dd/yyyy')}`
                  : "Select date range"}
              </div>
              <div className="date-range-calendars">
                <div>
                  <h6>From</h6>
                  <DatePicker
                    selected={tempStartDate}
                    onChange={(date) => {
                      setTempStartDate(date);
                      if (tempEndDate && date > tempEndDate) {
                        setTempEndDate(null);
                      }
                    }}
                    selectsStart
                    startDate={tempStartDate}
                    endDate={tempEndDate}
                    inline
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </div>
                <div>
                  <h6>To</h6>
                  <DatePicker
                    selected={tempEndDate}
                    onChange={(date) => setTempEndDate(date)}
                    selectsEnd
                    startDate={tempStartDate}
                    endDate={tempEndDate}
                    minDate={tempStartDate}
                    inline
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </div>
              </div>
              <div className="date-range-actions">
                <button
                  className="date-range-apply"
                  onClick={applyDateRange}
                >
                  Apply Filter
                </button>
                <button
                  className="date-range-cancel"
                  onClick={cancelDateSelection}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

      {/* Ticket Details Modal */}
      <TicketDetailsModal
        isOpen={isTicketDetailsModal}
        onClose={() => setIsTicketDetailsModal(false)}
        ticketData={selectedTicket}
      />

      {/* Image Modal for Full Screen View */}
      <ImageModal
        isOpen={imageModalOpen}
        onClose={() => setImageModalOpen(false)}
        imageSrc={imageModalSrc}
      />

      {/* Recommendation Modal */}
      {isRecommendationModal && (
        <div className="recommendation-modal-overlay" onClick={() => setIsRecommendationModal(false)}>
          <div className="recommendation-modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="recommendation-modal-close" onClick={() => setIsRecommendationModal(false)}>
              &times;
            </button>
            
            <div className="recommendation-modal-content">
              <div className="recommendation-tabs">
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'guide' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('guide')}
                >
                  Guidance
                </button>
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('checklist')}
                >
                  Action Checklist
                </button>
              </div>

              {/* GUIDANCE TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'guide' ? 'active' : ''}`}>
                <div className="guide-intro">
                  BrandSek continuously monitors domain registrations that closely resemble the organization's
                  legitimate domains. These look-alike domains are frequently used for phishing, brand impersonation,
                  credential harvesting, and financial fraud.
                </div>

                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>What Are Look-Alike Domains</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Look-alike domains are internet domains that visually, phonetically, or structurally resemble
                      a legitimate brand domain. Attackers register these domains to deceive users into believing
                      they belong to the real organization.
                    </p>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Detection Coverage</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Typographical variations (typosquatting)</li>
                      <li>Hyphenated, prefixed, or suffixed domain patterns</li>
                      <li>Alternate TLDs and country-code domains</li>
                      <li>IDN / Unicode homograph domains</li>
                      <li>Recently registered domains abusing brand keywords</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>How Look-Alike Domains Are Abused</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Phishing emails impersonating the brand or executives</li>
                      <li>Fake login pages to harvest credentials</li>
                      <li>Payment diversion and invoice fraud</li>
                      <li>Malware delivery or redirection campaigns</li>
                      <li>Reputation damage and customer trust erosion</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Risk Indicators Considered</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Domain naming similarity score</li>
                      <li>WHOIS privacy and recent registration</li>
                      <li>Suspicious DNS and hosting infrastructure</li>
                      <li>Malicious IP reputation and past abuse history</li>
                      <li>Presence of email (MX) records or web content</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Legal & Compliance Impact</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Look-alike domain abuse may result in fraud, customer data compromise, and regulatory exposure.
                      Proactive detection and takedown supports ISO 27001 brand protection controls, RBI cyber
                      fraud prevention guidance, and CERT-In advisories.
                    </p>
                  </div>
                </details>
              </div>

              {/* CHECKLIST TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}>
                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Risk Validation & Classification</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Validate similarity to legitimate brand domain</li>
                      <li>Review WHOIS and registration metadata</li>
                      <li>Assess hosting, DNS, and IP reputation</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.7 · Threat Intelligence</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Phishing & Abuse Assessment</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Check for active web or phishing content</li>
                      <li>Verify presence of email (MX) records</li>
                      <li>Correlate with phishing or fraud incidents</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.8.16 · RBI Fraud Prevention</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Takedown & Mitigation</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Initiate registrar or hosting takedown request</li>
                      <li>Notify internal stakeholders and SOC</li>
                      <li>Block domain at email and network gateways</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.8.20 · CERT-In</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Continuous Monitoring & Governance</h3>
                      <span className="severity-badge low">Low</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Monitor for re-registration or reuse</li>
                      <li>Track takedown status and closure</li>
                      <li>Maintain evidence for audit and legal review</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.25 · Brand Governance</div>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Domains;
